/**
 * `IdentifiersSection` - id / legacy_id / ext_account_id / legacy_username.
 *
 * `legacy_username` is PII (per `06-data-design.md` Section 1) and so is
 * rendered through `MaskedField`. The other three are non-PII and shown
 * verbatim - `id` as a copyable monospace block, `legacy_id` as a number,
 * `ext_account_id` as the dense human reference key.
 */
import type { Account, BffClient } from '../../../lib/bff-client'
import { MaskedField } from '../../../components/masked-field'
import { Field, FieldValue, MonoCode, Section } from './section'

export interface IdentifiersSectionProps {
  readonly account: Account
  readonly client: BffClient
  readonly onAuthError?: ((err: unknown) => void) | undefined
}

export function IdentifiersSection({
  account,
  client,
  onAuthError,
}: IdentifiersSectionProps): JSX.Element {
  return (
    <Section title="Identifiers">
      <Field label="SM2 id">
        <MonoCode value={account.id} />
      </Field>
      <Field label="Legacy id">
        <FieldValue value={account.legacy_id as string | number} />
      </Field>
      <Field label="External account id">
        <span className="font-mono text-murmuration-code">{account.ext_account_id}</span>
      </Field>
      <Field label="Legacy username">
        <MaskedField
          client={client}
          accountId={account.id}
          field="legacy_username"
          value={account.legacy_username}
          label="legacy username"
          onAuthError={onAuthError}
        />
      </Field>
    </Section>
  )
}
